export const apiErrorsActionTypes = {
  API_UNAUTHORIZED_ERROR: 'API_UNAUTHORIZED_ERROR'
};
